define('drops/contentRegion/contentRegion',[
    'jquery',
    'underscore',
    'lq/style',
    'drops/action/action',
    'lq/layouting',
    'lq/responsive',
    'lq/validatorGateway',
    'lq/drop',
    'when',
    'lq/highlighter'
], function ($, _, Style, Action, layouting, responsive, validatorGateway, Drop, when, highlighter) {
    'use strict';

    var defaults = {
        data: {
            sharedParameters: [],
            eventsToCatch: []
        }
    };

    var ContentRegion = function (options) {
        Drop.call(this, $('<div/>'), defaults, options);
        Style.renderStyles(this);

        this.$wrapper = $('<div class="licquid-action-wrapper" />')
            .css({
                width: '100%',
                height: '100%'
            })
            .appendTo(this.$element);
        this.$view = $('<div class="licquid-action-view" />')
            .appendTo(this.$wrapper);

        this.onEventReceived = this.receiveEvent.bind(this);

        this.bindingsOfThisAction = undefined;
        this.bindingsOfChildAction = undefined;
    };

    Drop.extend(ContentRegion, Drop);

    ContentRegion.typeName = 'ContentRegion';

    ContentRegion.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.applyPosition();

        if (!validatorGateway.isEnabled()) {
            var self = this;
            this.gatewayCallback = function () {
                if (!self.action) return;
                self.informValidator(self.action, false);
            };
            validatorGateway.whenEnabled(this.gatewayCallback);
        }
    };

    ContentRegion.prototype.copyParameterToChild = function (sharedParameter, newValue, parameterType) {
        if (!this.action) return;
        this.copyParameterToPiping(this.action.piping, sharedParameter, newValue, parameterType);
    };

    ContentRegion.prototype.copyParameterFromChild = function (sharedParameter, newValue, parameterType) {
        this.copyParameterToPiping(this.piping, sharedParameter, newValue, parameterType);
    };

    ContentRegion.prototype.copyParameterToPiping = function (targetPiping, sharedParameter, newValue, parameterType) {
        if (this.updating) return;

        this.updating = true;

        if (parameterType === 'local')
            targetPiping.parameters.locals.setValue(sharedParameter, newValue);

        if (parameterType === 'global')
            targetPiping.parameters.globals.setValue(sharedParameter, newValue);

        if (parameterType === 'system')
            targetPiping.parameters.systems.setValue(sharedParameter, newValue);

        this.updating = false;
    };

    ContentRegion.prototype.setContent = function (contentArray, locals, insertionPoint) {
        var self = this;
        
        if (!this.bindingsOfThisAction) {
            this.bindingsOfThisAction = _.map(this.data.sharedParameters, function (sharedParameter) {
                return self.piping.parameters.subscribeForUpdates(sharedParameter, self.copyParameterToChild.bind(self, sharedParameter));
            });
        }

        if (insertionPoint && insertionPoint !== this.rootDrop.data.id) {
            this.action.setContent(contentArray, locals, insertionPoint);
        } else {
            var actionData = contentArray[0].action;

            this.triggerEventIfEnabled('contentLoading', actionData.id);

            var systemParameters = contentArray[0].systemParameters;
            var localParameters = contentArray.length > 1 ? {} : locals;

            var action = new Action(actionData.view, this.piping.application.options);
            action.loadData(actionData);
            action.piping = this.piping.createChildPiping(actionData, action, localParameters, systemParameters, this.$wrapper, this.$view, false);
            action.piping.eventing.addAfterInterceptor(this.onEventReceived);

            action.globals = _.clone(this.piping.parameters.globals.getAll());
            action.locals = _.clone(locals);

            var layout = responsive.getCurrentLayout(action);
            layouting.applyLayout(this.$view, layout);
            action.applyLayout(layout, false);

            if(document.startViewTransition) {
                var transition = document
                    .startViewTransition(() => {
                        var promise = this.startActionRender(action, actionData);
                        this.postActionRender(action, contentArray, locals);
                        return promise;
                    });
                transition.updateCallbackDone
                    .then(() => action.startEventing());
            } else {
                this.startActionRender(action, actionData)
                    .then(function() {
                        action.startEventing();
                    });
                this.postActionRender(action, contentArray, locals);
            }
        }
    };

    ContentRegion.prototype.startActionRender = function (action, actionData) {
        var self = this;
        return action.createAndRenderDrops($())
            .then(function () {
                self.triggerEventIfEnabled('contentLoaded', actionData.id);
            });
    };

    ContentRegion.prototype.postActionRender = function (action, contentArray, locals) {
        if (validatorGateway.isEnabled()) {
            var canReload = contentArray.length === 1; // only the inner-most action can be reloaded
            this.informValidator(action, canReload);
        }

        if (contentArray.length > 1) {
            action.setContent(contentArray.slice(1), locals);
        }

        var self = this;
        _.each(this.data.sharedParameters, function (sharedParameter) {
            if (action.piping.parameters.locals.parameterExists(sharedParameter))
                self.piping.parameters.locals.setValue(sharedParameter, action.piping.parameters.locals.getValue(sharedParameter));
            if (action.piping.parameters.globals.parameterExists(sharedParameter))
                self.piping.parameters.globals.setValue(sharedParameter, action.piping.parameters.globals.getValue(sharedParameter));
        });

        var bindingsOfChildAction = _.map(this.data.sharedParameters, function (sharedParameter) {
            return action.piping.parameters.subscribeForUpdates(sharedParameter, self.copyParameterFromChild.bind(self, sharedParameter));
        });

        // CurrentActionId is a special case: this parameter should always contain the id of the lowest child
        this.piping.parameters.systems.setValue('CurrentActionId', action.data.id);
        
        bindingsOfChildAction
            .push(action.piping.parameters.subscribeForSystemUpdates('CurrentActionId', self.copyParameterFromChild.bind(this, 'CurrentActionId')));
        
        if (this.$element.css('position') === 'relative') {
            if (action.data.makeItGrow) {
                this.$element.css('height', 'auto');
            } else if (isNaN(action.data.top) || isNaN(action.data.height)) {
                this.$element.css('height', action.data.size.y + 'px');
            } else {
                this.$element.css('height', '20px');
            }
        }

        this.cleanupCurrentAction();

        this.action = action;
        this.bindingsOfChildAction = bindingsOfChildAction;

        this.piping.busyIndicator.forceHide();
    };

    ContentRegion.prototype.receiveMessage = function (message) {
        switch (message.type) {

            case 'RELOAD_ACTION_INSTANCE':
                this.piping.runtime.actionLoader.load(this.action.data.id, this.action.globals, this.action.locals, { ignoreHistory: true }, []);
                break;

            case 'HIGHLIGHT_ACTION_INSTANCE':
                highlighter.highlight(this.$wrapper);
                break;

        }
    };

    ContentRegion.prototype.informValidator = function (action, canReload) {
        validatorGateway.registerListener(action.instanceId, this.receiveMessage.bind(this));

        validatorGateway.publishEvent({
            type: 'ACTION_INSTANCE_LOADED',
            action: action,
            parentInstanceId: this.rootDrop.instanceId,
            canReload: canReload
        });
    };

    ContentRegion.prototype.cleanupCurrentAction = function () {
        if (!this.action) return;

        if (validatorGateway.isEnabled()) {
            validatorGateway.publishEvent({
                type: 'ACTION_INSTANCE_UNLOADING',
                action: this.action
            });
        }

        this.action.piping.eventing.removeInterceptor(this.onEventReceived);
        this.action.piping.cleanUp();
        this.action.unsubscribeEventHandlersRecursive();

        if (validatorGateway.isEnabled()) {
            validatorGateway.unregisterListener(this.action.instanceId);
        }

        this.disposeBindings(this.bindingsOfChildAction);

        this.action = null;
    };

    ContentRegion.prototype.disposeBindings = function (bindings) {
        _.each(bindings, function (binding) {
            binding.dispose();
        });
    };

    ContentRegion.prototype.unsubscribeEventHandlers = function () {
        this.cleanupCurrentAction();

        if (this.gatewayCallback) {
            validatorGateway.removeCallback(this.gatewayCallback);
        }

        this.disposeBindings(this.bindingsOfThisAction);
    };

    ContentRegion.prototype.receiveEvent = function (e) {
        if (!this.data.eventsToCatch || this.data.eventsToCatch.indexOf(e.eventName) === -1)
            return;

        var deferred = when.defer();

        var args = e.args ? e.args[0] : null;
        this.piping.eventing.publish(
            this.data.id + '.' + e.eventName,
            undefined,
            args,
            function () {
                deferred.resolve();
            },
            e.parentEventAction);

        return deferred.promise;
    };

    return ContentRegion;
});
